import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { BrowserRouter, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getUserInfoAction, removeNotificationAction } from './actions/Actions';
import Header from "./components/header/Header";
import Dashboard from "./components/dashboard/Dashboard";
import Footer from "./components/footer/Footer";
import NotificationBox from './components/notification/NotificationBox';
import config from "./config";
import UserApi from './api/UserApi';

import moment from 'moment';
import 'moment/locale/ru';
import 'moment/locale/kk';

class App extends Component {
  state = {
    userCanUseService: null
  };

  componentDidMount() {
    UserApi.checkUser().then(({ data: userCanUseService }) => {
      this.setState({ userCanUseService });
    }).catch(() => {
      this.setState({ userCanUseService: false });
    });
  }

  render() {
    const { lang, closeNotification } = this.props;
    const { userCanUseService } = this.state;
    moment.locale(lang);
    return (
      <div>
        <BrowserRouter>
          <Route component={Header} />
        </BrowserRouter>
        <main role="main" className="main">
          {
            userCanUseService === null
              ? <article className="article">
                  <p>Идет загрузка, пожалуйста, подождите...</p>
                </article>
              : userCanUseService
                  ? <Dashboard lang={lang} accessPermissions={userCanUseService} />
                  : <article className="article">
                      <p>Ошибка! У Вас нет доступа к работе в этой системе. Обратитесь к своему администратору.</p>
                      <a href={config.accountsUrl}>Перейти на страницу кабинета</a>
                    </article>
          }
        </main>
        <Footer lang={lang} />
        <NotificationBox
          headerHeight={88}
          closeNotification={closeNotification}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    userInfo: state.userInfo,
    lang: state.lang,
    customer: state.customer
  }),
  dispatch => ({
    getCustomers: bindActionCreators(getUserInfoAction, dispatch),
    closeNotification: bindActionCreators(removeNotificationAction, dispatch),
  }),
)(withRouter(App));
